"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDomain = void 0;
/** Browser builds do not perform backend policy normalization; fail closed if called accidentally. */
const getDomain = () => null;
exports.getDomain = getDomain;
